// =================================================================
// Engine: Patient context modifiers (PSD §4.2 / TODO Task 2.6)
// =================================================================
import { FluidStatus } from '@amino-pk/shared-types';
/**
 * Apply context modifiers (FR-1.3). Critical illness, obesity, ARC, altered Vd.
 */
export function applyContextModifiers(patient, baseVdLkg) {
    const warnings = [];
    let pathwayReroute = null;
    let adjustedVdLkg = null;
    const active = (t) => patient.contextModifiers?.some((m) => m.type === t && m.active) ?? false;
    if (active('critical-illness')) {
        warnings.push('Critical illness — Vd may be increased; consider early peak/trough confirmation.');
    }
    if (active('obesity')) {
        adjustedVdLkg = baseVdLkg * 1.1;
        warnings.push('Obesity — adjusted Vd applied; dosing weight should use AdjBW.');
    }
    if (active('augmented-clearance')) {
        warnings.push('Augmented renal clearance (ARC) — subtherapeutic peaks possible; consider q12h pathway.');
        pathwayReroute = 'high-clearance-q12h';
    }
    if (active('altered-vd')) {
        warnings.push('Altered Vd (fluid shifts) — early level confirmation recommended.');
        adjustedVdLkg = adjustedVdLkg ?? baseVdLkg * 1.15;
    }
    // Fluid-status branches (FE-E3, FE-E4)
    if (patient.fluidStatus === FluidStatus.Hypervolemic) {
        adjustedVdLkg = (adjustedVdLkg ?? baseVdLkg) * 1.15;
        warnings.push('Hypervolemic — Vd increased (~+15%); consider early peak confirmation.');
    }
    else if (patient.fluidStatus === FluidStatus.Hypovolemic) {
        warnings.push('Hypovolemic — Vd may be reduced; risk of over-exposure. Confirm level before dose escalation.');
    }
    // Euvolemic → unchanged
    return { warnings, pathwayReroute, adjustedVdLkg };
}
/** Assess nephrotoxin risk multiplier + monitoring frequency adjustment. */
export function assessNephrotoxinRisk(toxins, durationDays) {
    const count = toxins.filter((t) => t.active).length;
    let riskMultiplier = 1.0;
    if (count >= 3)
        riskMultiplier = 2.0;
    else if (count === 2)
        riskMultiplier = 1.5;
    else if (count === 1)
        riskMultiplier = 1.2;
    const frequencyAdjustmentDays = count >= 2 && durationDays > 5 ? 1 : count >= 1 ? 2 : 3;
    return { riskMultiplier, frequencyAdjustmentDays };
}
//# sourceMappingURL=context.js.map